import React from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";

const MultipleChoiceQuestion = ({
  question,
  options,
  selectedOptions,
  optionStatuses,
  onOptionToggle,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  const selected = Array.isArray(selectedOptions) ? selectedOptions : [];

  return (
    <>
      <div className="test-question question-title" dangerouslySetInnerHTML={{ __html: question || "" }} />
      <FormGroup className="multiple-choice-options">
        {(options || []).map((option) => {
          const status = optionStatuses[option.id];
          return (
            <FormControlLabel
              key={option.id}
              className={status ? `multiple-choice-option ${status}` : "multiple-choice-option"}
              control={(
                <Checkbox
                  checked={selected.includes(option.id)}
                  onChange={() => onOptionToggle(option.id)}
                  disabled={!showCheckButton}
                />
              )}
              label={<span><strong>{option.id}.</strong> <span dangerouslySetInnerHTML={{ __html: option.text || "" }} /></span>}
            />
          );
        })}
      </FormGroup>

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>Перевірити</button>
      )}
      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}
      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>Наступне завдання</button>
      )}
      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>Завершити</button>
      )}
    </>
  );
};

export default MultipleChoiceQuestion;
